/**
 * Created by Daniel on 5/4/17.
 */

import React, { Component } from "react";
import AddDevicesToTest from "../presentation/AddDevicesToTest";
import dynamicSort from "../../logic/DynamicSort";

class AddDevicesToTestWidget extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      devices: [],
      clusters: [],
      selectedDevices: props.currentDevices,
      clusterName: "",
      clusterComments: "",
      errorField: "",
      success: "",
      error: "",
      clusterDevices: [],
      search: "",
      devicesClicked: true,
      sort: "name",
      sortAsc: "true",
      sortLocal: "name",
      sortLocalAsc: true,
      testInstanceId: props.testInstanceId
    };
  }

  componentDidMount() {
    this.getDeviceList();
  }

  updateDeviceList = deviceId => {
    const selectedDevice = this.state.devices.find(device => device._id === deviceId)
    const devices = this.state.devices.filter(device => device._id !== deviceId)
    const selectedDevices = [ ...this.state.selectedDevices, selectedDevice ]
    
    this.setState({ selectedDevices, devices });
  };

  removeDevice = deviceId => {
    const device = this.state.selectedDevices.find(selectedDevice => selectedDevice._id === deviceId)
    const selectedDevices = this.state.selectedDevices.filter(selectedDevice => selectedDevice._id !== deviceId)
    const devices = [ ...this.state.devices, device ]
    
    this.setState({ selectedDevices, devices });
  };

  mergeToSelectedDevices = devices => {
    let selectedDevices = this.state.selectedDevices;
    let result = "";
    devices.map(device => {
      result = this.state.selectedDevices.find(
        selectedDevice => selectedDevice._id === device._id
      );

      if (result == null) {
        selectedDevices.push(device);
      }
    });

    this.setState({ selectedDevices });
  };

  removeClusterDevice = deviceId => {
    const { selectedDevices } = this.state
    const device = selectedDevices.find(selectedDevice => selectedDevice._id === deviceId);
    selectedDevices.splice(selectedDevices.indexOf(device), 1);

    this.setState({ selectedDevices });
  };

  getDeviceList = () => {
    this.setState(
      { devicesClicked: "true", clusters: [], isLoading: true },
      () => {
        fetch(
          "/service/devices?search=" +
            this.state.search +
            "&sort=" +
            this.state.sort +
            "&sortAsc=" +
            this.state.sortAsc +
            "&registeredOnly=true",
          {
            method: "GET",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json"
            },
            credentials: "same-origin"
          }
        ).then(response => {
          if (response.status !== 200) {
            this.setState({
              serverError:
                "Please add devices from the Device Management section to display.",
              isLoading: false
            });
          } else {
            response.json().then(json => {
              let devices = json;
              let selectedDevices = this.state.selectedDevices;
              if (selectedDevices.length) {
                let result = "";

                selectedDevices.map(selectedDevice => {
                  result = devices.find(
                    device => device._id === selectedDevice._id
                  );

                  if (result) {
                    devices.splice(devices.indexOf(result), 1);
                  }
                });
              }
              this.setState({
                devices: devices,
                clusters: "",
                clusterDevices: "",
                isLoading: false
              });
            });
          }
        });
      }
    );
  };

  getClusters = () => {
    this.setState(
      { devicesClicked: false, devices: [], isLoading: true },
      () => {
        fetch(
          "/service/clusters?search=" +
            this.state.search +
            "&sort=" +
            this.state.sort +
            "&sortAsc=" +
            this.state.sortAsc,
          {
            method: "GET",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json"
            },
            credentials: "same-origin"
          }
        ).then(response => {
          if (response.status !== 200) {
            response.json().then(json => {
              this.setState({
                serverError:
                  "Please add clusters from the Device Management section to display.",
                isLoading: false
              });
            });
          } else {
            response.json().then(clusters => {
              this.setState({ clusters, isLoading: false });
            });
          }
        });
      }
    );
  };

  getClusterDevices = cluster => {
    let devices = cluster.devices;
    this.setState({
      clusterName: cluster.name,
      clusterComments: cluster.comments
    });

    fetch("/service/getClusterDevices?devices=" + devices, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      credentials: "same-origin"
    }).then(response => {
      if (response.status === 200) {
        response.json().then(clusterDevices => {
          this.setState({ clusterDevices });
          this.mergeToSelectedDevices(clusterDevices);
        });
      }
    });
  };

  removeCluster = cluster => {
    const deviceIds = cluster.devices;

    this.setState(prevState => {
      let selectedDevices = Object.values({ ...prevState.selectedDevices });

      selectedDevices = selectedDevices.filter(
        device => !deviceIds.includes(device._id)
      );

      return {
        selectedDevices
      };
    });
  };

  handleSave = () => {
    let selectedDevices = this.state.selectedDevices;
    this.props.updateTestDevices(selectedDevices);
  };

  updateSearchState = e => {
    if (this.state.devicesClicked === "true") {
      this.setState({ search: e.target.value }, () => {
        this.getDeviceList();
      });
    } else {
      this.setState({ search: e.target.value }, () => {
        this.getClusters();
      });
    }
  };

  updateSortState = sortBy => {
    if (this.state.devicesClicked === "true") {
      if (sortBy == this.state.sort) {
        this.setState(
          prevState => ({ sortAsc: !prevState.sortAsc }),
          this.getDeviceList
        );
      } else {
        this.setState({ sort: sortBy }, this.getDeviceList);
      }
    } else {
      if (sortBy == this.state.sort) {
        this.setState(
          prevState => ({ sortAsc: !prevState.sortAsc }),
          this.getClusters
        );
      } else {
        this.setState({ sort: sortBy }, this.getClusters);
      }
    }
  };

  sortLocalTable = sortByLocal => {
    let updateSortedList = () => {
      this.setState(prevState => ({
        selectedDevices: prevState.selectedDevices.sort(
          dynamicSort(this.state.sortLocal, this.state.sortLocalAsc ? 1 : -1)
        )
      }));
    };

    if (sortByLocal === this.state.sortLocal) {
      this.setState(
        prevState => ({ sortLocalAsc: !prevState.sortLocalAsc }),
        updateSortedList
      );
    } else {
      this.setState({ sortLocal: sortByLocal }, updateSortedList);
    }
  };

  goBack = () => {
    this.props.navigator.requestAddNewTestInstance();
    this.props.toggleAddDevices();
  };

  render() {
    return (
      <AddDevicesToTest
        navigator={this.props.navigator}
        loadData={this.state}
        updateDeviceList={this.updateDeviceList}
        removeDevice={this.removeDevice}
        updateSearchState={this.updateSearchState}
        updateSortState={this.updateSortState}
        getClusters={this.getClusters}
        getDevices={this.getDeviceList}
        getClusterDevices={this.getClusterDevices}
        removeCluster={this.removeCluster}
        handleSave={this.handleSave}
        goBack={this.goBack}
        sortLocalTable={this.sortLocalTable}
      />
    ); //return
  } //render
} //AddDevicesToTest

export default AddDevicesToTestWidget;
